import { TravelTypes } from '../../constants';

const checkIsFlightTripSearch = (isTripSearch) => (state) => {
  const { travelOptions = [] } = state.tripSearch.searchResult || {};
  return (
    isTripSearch ||
    (Array.isArray(travelOptions) &&
      travelOptions.length > 0 &&
      travelOptions[0].mode === TravelTypes.flight)
  );
};
export default checkIsFlightTripSearch;
